import React, { Component } from 'react';
import PropTypes from 'prop-types';


export class RePay extends Component {
    constructor(props) {
        super(props);
        this.handleFrameMessage = this.handleFrameMessage.bind(this);
    }
    componentDidMount() {
        this.paymentFrame.onload = () => {
            window.addEventListener("message",this.handleFrameMessage);
        }
    }
    componentWillUnmount() {
        window.removeEventListener("message", this.handleFrameMessage);
    }

    handleFrameMessage(e){     
        const {data} = e; 
        if(data)  
        {
            this.props.onMessage(data);
        }     
    }

    render(){
        const {iframeStyle} = this.props;         
        return (
            <div  style={iframeStyle}>
                <iframe src={this.props.paymentUrl} title="Payment" id='repayFrame' style={{ width:'100%', border:'0px'}}
                ref={(f) => this.paymentFrame = f} />            
            </div>
        )
    }
}

RePay.propTypes = {
    paymentUrl: PropTypes.string, 
    onMessage: PropTypes.func,
    iframeStyle: PropTypes.object,
}
RePay.defaultProps = {
    iframeStyle: { minHeight: '95vh', width: '100%', border: '0px', display: 'flex' }
};


// WEBPACK FOOTER //
// ./src/components/subcomponents/RePay.jsx